import { ConsolePage } from './pages/ConsolePage';

function App() {
  return (
    <div data-component="App" className="w-full h-full">
      <ConsolePage />
    </div>
  );
}

export default App;
